import { RateCategoryEnum } from '@cai-services';

const AirportNamesToAvoid = [
    null,
    '',
    ' ',
    'airport',
    'bus station',
    'city airport',
    'heliport',
    'international',
    'municipal',
    'off-line point',
    'railway station',
    'regional',
  ],
  AllowedFileTypes: string[] = [
    '.csv',
    '.doc',
    '.docx',
    '.jpg',
    '.pdf',
    '.png',
    '.txt',
    '.xls',
    '.xlsx',
  ];

function addToList(propertyList: string[], property: string) {
  const idx = propertyList.indexOf(property);
  if (idx < 0) {
    propertyList.push(property);
  }
}

function rmvFrList(propertyList: string[], property: string) {
  const idx = propertyList.indexOf(property);
  if (idx >= 0) {
    propertyList.splice(idx, 1);
  }
}

function displayRateType(type: string): string {
  return type === 'ContractPromo'
    ? 'C-Promo'
    : type == 'Ai'
      ? 'Ai-Powered'
      : type;
}

function displayAircraftTypes(aircraftTypes: string): string {
  return aircraftTypes === 'FF NB WB' ? 'ALL' : aircraftTypes;
}

function renderAirlineProdCode(airlineProdCode, commodity: string) {
  if (!airlineProdCode) {
    return commodity;
  }
  return airlineProdCode;
}

function tipsAirlineProdCode(
  airlineProdCode,
  commodity,
  airlineRateRemarks: string,
) {
  if (!airlineProdCode) {
    return airlineRateRemarks ? '  Remarks:' + airlineRateRemarks : '';
  }
  return (
    'Commodity:' +
    commodity +
    (airlineRateRemarks ? '  Remarks:' + airlineRateRemarks : '')
  );
}

function hideDefaultColumns(
  paginatedRates: any,
  rateCategory: RateCategoryEnum,
  displayedColumns: string[],
) {
  if (!paginatedRates.content.some((rate) => !!rate.shcs)) {
    rmvFrList(displayedColumns, 'shcs');
  }
  if (!paginatedRates.content.some((rate) => !!rate.airlineProdCode)) {
    rmvFrList(displayedColumns, 'airlineProdCode');
  } else {
    rmvFrList(displayedColumns, 'commodity');
  }
  if (
    !paginatedRates.content.find(
      (rate) =>
        rate.aircraftTypes !== 'ALL' && rate.aircraftTypes !== 'FF NB WB',
    )
  ) {
    rmvFrList(displayedColumns, 'aircraftTypes');
  }
  if (!paginatedRates.content.find((rate) => rate.density !== '1:6')) {
    rmvFrList(displayedColumns, 'density');
  }
  if (!paginatedRates.content.find((rate) => rate.flightNo !== 'ALL')) {
    rmvFrList(displayedColumns, 'flightNo');
  }
  if (!paginatedRates.content.find((rate) => rate.day !== '1234567')) {
    rmvFrList(displayedColumns, 'day');
  }
  if (!paginatedRates.content.find((rate) => rate.fuelSurcharge !== 0)) {
    rmvFrList(displayedColumns, 'fuelSurcharge');
  }
  if (!paginatedRates.content.find((rate) => rate.securitySurcharge !== 0)) {
    rmvFrList(displayedColumns, 'securitySurcharge');
  }
  if (!paginatedRates.content.find((rate) => rate.miscellaneousCharge !== 0)) {
    rmvFrList(displayedColumns, 'miscellaneousCharge');
  }
  if (!paginatedRates.content.find((rate) => rate.saf !== 0)) {
    rmvFrList(displayedColumns, 'saf');
  }
  if (!paginatedRates.content.find((rate) => rate.iatacass)) {
    rmvFrList(displayedColumns, 'iatacass');
  }
  if (rateCategory === RateCategoryEnum.WEIGHT) {
    WeightTypeRateList.forEach((col, idx) => {
      if (
        idx > 1 &&
        !paginatedRates.content.find(
          (rate) =>
            rate.rates && rate.rates[idx] && rate.rates[idx].amount !== 0,
        )
      ) {
        rmvFrList(displayedColumns, col);
      }
    });
  } else if (rateCategory === RateCategoryEnum.ULD) {
    ULDTypeRateList.forEach((col, idx) => {
      if (
        idx > 1 &&
        !paginatedRates.content.find(
          (rate) =>
            rate.uldRate &&
            rate.uldRate[ULDTypeRateList[idx]] &&
            rate.uldRate[ULDTypeRateList[idx]] !== 0,
        )
      ) {
        rmvFrList(displayedColumns, col);
      }
    });
  }
}

const WeightTypeRateList = [
    'M',
    'N',
    'kg45',
    'kg100',
    'kg300',
    'kg500',
    'kg1000',
    'kg3000',
  ],
  ULDTypeRateList = ['amount', 'pivotWeight', 'overPivot', 'maxWeight'];

function sortCompare(
  a: number | string | boolean,
  b: number | string | boolean,
  isAsc: boolean,
) {
  if ((a === undefined || a === null) && (b === undefined || b === null)) {
    return 0;
  }
  if (a === undefined || a === null) {
    return -1 * (isAsc ? 1 : -1);
  }
  if (b === undefined || b === null) {
    return 1 * (isAsc ? 1 : -1);
  }
  if (a == b) {
    return 0;
  }
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

function sortCompare2(
  a1: number | string | boolean,
  b1: number | string | boolean,
  isAsc1: boolean,
  a2: number | string | boolean,
  b2: number | string | boolean,
  isAsc2: boolean,
) {
  const result = sortCompare(a1, b1, isAsc1);
  if (result == 0) {
    return sortCompare(a2, b2, isAsc2);
  } else {
    return result;
  }
}

export {
  AirportNamesToAvoid,
  AllowedFileTypes,
  ULDTypeRateList,
  WeightTypeRateList,
  addToList,
  displayAircraftTypes,
  displayRateType,
  hideDefaultColumns,
  renderAirlineProdCode,
  rmvFrList,
  sortCompare,
  sortCompare2,
  tipsAirlineProdCode,
};
